import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { useMemo } from 'react';
import { CustomStyledLabel } from '../../../request-service';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
export const CustomerAccountSelectedEquipmentHeading = ({ children, showTooltip = true, className, ...headingProps }) => {
    const label = useMemo(() => {
        const headingClass = showTooltip ? 'text-truncate d-block' : '';
        return (_jsx(CatHeading, { slot: "trigger", ...headingProps, children: _jsx(CustomStyledLabel, { children: _jsx("span", { className: headingClass, children: children }) }) }));
    }, [children, headingProps, showTooltip]);
    return (_jsx("div", { className: className, children: showTooltip ? (_jsxs(CatTooltip, { position: "auto", children: [label, _jsx(CatTextPassage, { children: children })] })) : (_jsx(_Fragment, { children: label })) }));
};
